export default __webpack_public_path__ + "static/media/googlePlayRes.ead249e3.svg";